// Packages
import React, { useCallback, useContext, useEffect } from 'react';

// Components
import SHDThemeOverride from '@ui/ThemeOverride/SHDThemeOverride';
import PaywallCtaInner from './components/PaywallCtaInner';

import { usePaywallTracking } from '@hooks/revcat/usePaywallTracking';
import { getPaywallCtaCopy, getPaywallLockCopy } from './paywall.copy';

import { UserContext } from '@services/Session';

// Components
import { Box } from 'grommet';

// Types
import {
  PaywallCtaProps,
  PaywallPageContext,
  PaywallEvents,
} from './paywall.types';

const PaywallCta: React.FC<PaywallCtaProps> = ({
  context,
  mode = 'default',
  playerId = '',
  customCopy = null,
  isLoggedIn,
  onPaywallOpen,
  prices,
  isTray,
}) => {
  // Hooks();
  const { trackPaywallEvent } = usePaywallTracking(context, playerId);

  useEffect(() => {
    trackPaywallEvent(PaywallEvents.PAYWALL_DISPLAYED, {
      context: context,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const userStore = useContext(UserContext);
  const isUserLoggedIn = !!userStore.authUser;

  const { signIn } = getPaywallLockCopy(false, isLoggedIn || false, false);

  // Constants
  const { headline, copy } = getPaywallCtaCopy(prices.monthly, mode);

  const openPaywall = useCallback(() => {
    trackPaywallEvent(PaywallEvents.VIEW_PLANS_CLICKED, { context });
    onPaywallOpen();
  }, [onPaywallOpen, trackPaywallEvent, context]);

  const ctaContent = (
    <PaywallCtaInner
      viewButton={context === PaywallPageContext.VIEW_BUTTON}
      headline={headline}
      copy={copy}
      onClick={openPaywall}
      customCopy={customCopy || {}}
      signInUrl={signIn.linkUrl}
      isLoggedIn={isUserLoggedIn}
      isTray={isTray}
    />
  );

  return (
    <SHDThemeOverride full={false}>
      <Box>{ctaContent}</Box>
    </SHDThemeOverride>
  );
};

export default PaywallCta;
